<template>
  <v-dialog
    v-model="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    max-width="1000"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :scrollable="true"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-3"
          medium
          >{{ icon }}</v-icon
        >
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn
          v-if="
            $store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0 ||
            ($store.state.storePhotoGiftOrderDesign.maxTemplateClones > 0 &&
              $store.state.storePhotoGiftOrderDesign.itemCopies <
                $store.state.storePhotoGiftOrderDesign.maxTemplateClones)
          "
          text
          @click="clickBtn1"
          style="min-width: 0; width: 20px"
        >
          <v-icon :color="getTheme() == 'dark' ? 'white' : 'primary'"
            >mdi-close</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-card-text
        class="pt-6 pb-3"
        v-if="$store.state.storePhotoGiftOrderDesign.maxTemplateClones > 0"
      >
        <span
          v-if="
            $store.state.storePhotoGiftOrderDesign.itemCopies >=
            $store.state.storePhotoGiftOrderDesign.maxTemplateClones
          "
        >
          {{ $t("userNewPhotoGiftOrderDesignFinalizeMultipleToGoEnd") }}
        </span>
        <span v-else
          >{{ $t("userNewPhotoGiftOrderDesignFinalizeMultipleToGo") }}
          {{
            $store.state.storePhotoGiftOrderDesign.maxTemplateClones -
            $store.state.storePhotoGiftOrderDesign.itemCopies
          }}
          {{ $t("lmPcs") }}</span
        >
      </v-card-text>
      <v-card-text class="pt-6 pb-3" v-else>
        {{ $t("userNewPhotoGiftOrderDesignFinalizeMultipleQuestion") }}
      </v-card-text>

      <v-card-text
        class="pb-6 pa-0 ma-0 overline"
        v-if="$store.state.storePhotoGiftOrderDesign.maxTemplateClones > 0"
      >
        {{ $store.state.storePhotoGiftOrderDesign.itemCopies }} /
        {{ $store.state.storePhotoGiftOrderDesign.maxTemplateClones }}
        {{ $t("lmPcs") }}
      </v-card-text>
      <v-card-text class="pb-6 pa-0 ma-0 overline" v-else>
        {{ $t("settingsPhotoGiftPriceTitle") }}:
        {{ price($store.state.storePhotoGiftOrderDesign.itemFullPrice) }} /
        {{ $store.state.storePhotoGiftOrderDesign.itemCopies }}
        {{ $t("lmPcs") }}
      </v-card-text>

      <v-card-text class="pb-6">
        <!--<div>{{ $t("userNewPhotoGiftOrderDesignFinalizeMultipleBody") }}</div>-->
        <!-- IMAGE THUMBNAILS MAIN CONTENT -->
        <v-flex xs12 class="mx-1 mb-1 pa-0">
          <v-card outlined class="py-0 ma-0" style="background-color: silver">
            <v-card-text
              class="pa-0 ma-1 py-3 d-flex flex-row flex-wrap justify-center"
            >
              <div
                v-for="(item, index) in $store.state.storePhotoGiftOrderDesign
                  .multipleCopies"
                :key="index"
              >
                <v-img
                  width="150"
                  height="150"
                  :src="item.cUrl"
                  contain
                  class="ma-1"
                >
                  <div
                    class="d-flex flex-column justify-space-between"
                    style="height: 100%"
                  >
                    <div
                      class="d-flex flex-row flex-wrap align-center justify-space-between"
                    >
                      <v-btn
                        fab
                        v-show="
                          index <
                          $store.state.storePhotoGiftOrderDesign.multipleCopies
                            .length -
                            1
                        "
                        x-small
                        class="ma-1 elevation-0"
                        style="background: rgba(255, 0, 0, 0.4)"
                        @click="deleteItem(index)"
                        @click.stop
                      >
                        <v-icon medium color="white">mdi-trash-can</v-icon>
                      </v-btn>
                      <v-spacer
                        v-if="
                          $store.state.storePhotoGiftOrderDesign.allowCustomSize
                        "
                      ></v-spacer>
                      <span
                        v-if="
                          $store.state.storePhotoGiftOrderDesign.allowCustomSize
                        "
                        class="pa-1 subtitle-2 white--text"
                        style="
                          background: rgba(0, 0, 0, 0.4);
                          border-radius: 5px;
                        "
                        >{{ item.mySize }} ({{ item.size }})</span
                      >
                    </div>
                    <div
                      class="d-flex flex-row align-center justify-space-between"
                    >
                      <v-btn
                        fab
                        x-small
                        class="ma-1 ml-1 elevation-0"
                        :style="
                          item.copies > 1
                            ? 'background: rgba(0, 0, 0, 0.4)'
                            : 'background: rgba(0, 0, 0, 0)'
                        "
                        @click="
                          item.copies > 1 ? decCopies(index) : item.copies
                        "
                        @click.stop
                      >
                        <v-icon v-show="item.copies > 1" medium color="white"
                          >mdi-minus</v-icon
                        >
                      </v-btn>
                      <v-spacer></v-spacer>
                      <div
                        class="pa-1 subtitle-2 white--text"
                        style="
                          background: rgba(0, 0, 0, 0.4);
                          border-radius: 5px;
                        "
                        @click.stop
                      >
                        {{ item.copies }}
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn
                        fab
                        x-small
                        class="ma-1 mr-1 elevation-0"
                        style="background: rgba(0, 0, 0, 0.4)"
                        @click="incCopies(index)"
                        @click.stop
                      >
                        <v-icon medium color="white">mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-img>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-card-text>
      <v-card-actions
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
      >
        <v-spacer
          v-if="
            $store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0 ||
            ($store.state.storePhotoGiftOrderDesign.maxTemplateClones > 0 &&
              $store.state.storePhotoGiftOrderDesign.itemCopies <
                $store.state.storePhotoGiftOrderDesign.maxTemplateClones)
          "
        ></v-spacer>
        <v-btn
          v-if="
            $store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0 ||
            ($store.state.storePhotoGiftOrderDesign.maxTemplateClones > 0 &&
              $store.state.storePhotoGiftOrderDesign.itemCopies <
                $store.state.storePhotoGiftOrderDesign.maxTemplateClones)
          "
          color="primary"
          class="mt-2 mb-2"
          @click="clickBtn2"
          ><v-icon class="mr-2">mdi-plus</v-icon>{{ btn2Text }}</v-btn
        >
        <v-spacer
          v-if="
            $store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0 ||
            ($store.state.storePhotoGiftOrderDesign.maxTemplateClones > 0 &&
              $store.state.storePhotoGiftOrderDesign.itemCopies >=
                $store.state.storePhotoGiftOrderDesign.maxTemplateClones)
          "
        ></v-spacer>
        <v-btn
          v-if="
            $store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0 ||
            ($store.state.storePhotoGiftOrderDesign.maxTemplateClones > 0 &&
              $store.state.storePhotoGiftOrderDesign.itemCopies >=
                $store.state.storePhotoGiftOrderDesign.maxTemplateClones)
          "
          color="secondary"
          class="mt-2 mb-2"
          @click="clickBtn3"
        >
          <v-icon class="mr-2">mdi-cart</v-icon>
          {{ $t("commonNewOrderOrderFinalizeAllTitle") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-photo-gift-multiple",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    btn2Text: {
      type: String,
      required: false,
    },
    btn3Text: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    deleteItem(index) {
      this.$store.state.storePhotoGiftOrderDesign.itemCopies -= this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
        index
      ].copies;
      if (this.$store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0)
        if (this.$store.state.storePhotoGiftOrderDesign.allowCustomSize) {
          this.$store.state.storePhotoGiftOrderDesign.itemFullPrice -=
            this.$store.state.storePhotoGiftOrderDesign.multipleCopies[index]
              .copies *
            this.$store.state.storePhotoGiftOrderDesign.multipleCopies[index]
              .price;
        } else
          this.$store.state.storePhotoGiftOrderDesign.itemFullPrice -=
            this.$store.state.storePhotoGiftOrderDesign.multipleCopies[index]
              .copies * this.$store.state.storePhotoGiftOrderDesign.itemPrice;

      this.$store.state.storePhotoGiftOrderDesign.multipleCopies.splice(
        index,
        1
      );
    },
    decCopies(index) {
      this.$store.state.storePhotoGiftOrderDesign.multipleCopies[index]
        .copies--;
      this.$store.state.storePhotoGiftOrderDesign.itemCopies--;
      if (this.$store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0)
        if (this.$store.state.storePhotoGiftOrderDesign.allowCustomSize) {
          this.$store.state.storePhotoGiftOrderDesign.itemFullPrice -= this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
            index
          ].price;
        } else
          this.$store.state.storePhotoGiftOrderDesign.itemFullPrice -= this.$store.state.storePhotoGiftOrderDesign.itemPrice;
    },
    incCopies(index) {
      if (
        this.$store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0 ||
        (this.$store.state.storePhotoGiftOrderDesign.maxTemplateClones > 0 &&
          this.$store.state.storePhotoGiftOrderDesign.itemCopies <
            this.$store.state.storePhotoGiftOrderDesign.maxTemplateClones)
      ) {
        this.$store.state.storePhotoGiftOrderDesign.multipleCopies[index]
          .copies++;
        this.$store.state.storePhotoGiftOrderDesign.itemCopies++;
        if (this.$store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0)
          if (this.$store.state.storePhotoGiftOrderDesign.allowCustomSize) {
            this.$store.state.storePhotoGiftOrderDesign.itemFullPrice += this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
              index
            ].price;
          } else
            this.$store.state.storePhotoGiftOrderDesign.itemFullPrice += this.$store.state.storePhotoGiftOrderDesign.itemPrice;
      }
    },
    clickBtn1: function () {
      this.$store.state.storePhotoGiftOrderDesign.itemCopies -= this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
        this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length - 1
      ].copies;

      // zmanjšamo ceno zadnjega dodanega izdelka
      if (this.$store.state.storePhotoGiftOrderDesign.maxTemplateClones == 0)
        this.$store.state.storePhotoGiftOrderDesign.itemFullPrice -=
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
            this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length -
              1
          ].copies *
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
            this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length -
              1
          ].price;

      this.$emit("clickBtn1");
    },
    clickBtn2: function () {
      this.$emit("clickBtn2");
    },
    clickBtn3: function () {
      this.$emit("clickBtn3");
    },
  },
};
</script>

<style scoped>
</style>